<div class="flex between">
    <h3>Dokument hochladen</h3>
    <button mat-icon-button (click)="dialogRef.close(null)">
        <mat-icon>clear</mat-icon>
    </button>
</div>

<div>
    @if (progress$ | async) {
        <div class="progress">
            <div class="progress-title">
                {{ (progress$ | async)?.name }}
            </div>
            <div class="progress-bar">
                <div class="info">{{ info }}</div>
                <mat-progress-bar
                    [mode]="mode"
                    [value]="(progress$ | async)?.progress"
                    color="primary"
                ></mat-progress-bar>
            </div>
        </div>
    } @else {
        <div class="drop-zone" appDragDropFile (fileDropped)="onAdd($event, true)">
            <div>Datei hier her ziehen</div>
            <div>oder</div>

            <div>
                <button mat-stroked-button (click)="fileUpload.click()">Datei auswählen</button>
            </div>
            <input hidden type="file" #fileUpload [multiple]="false" [accept]="data.accept" (change)="onAdd($event)" />
        </div>
    }
</div>
